import Avatar from "../Avatar";
import { Beneficiary } from "../../services/queries/beneficiaries/types";
import { getInitials } from "../../utils";

interface BeneficiaryListProps {
  data: Beneficiary[];
  setSelectedBeneficiary: React.Dispatch<
    React.SetStateAction<Beneficiary | null>
  >;
}

export default function BeneficiaryList({
  data,
  setSelectedBeneficiary,
}: BeneficiaryListProps) {
  return (
    <div className="beneficiary-list">
      <div className="overflow-x-auto">
        <div className="flex space-x-4 items-center">
          {data.map((beneficiary) => {
            return (
              <div key={beneficiary.id} className="flex flex-col items-center">
                <Avatar
                  characters={getInitials(beneficiary.accountName)}
                  onClick={() => setSelectedBeneficiary(beneficiary)}
                />
                <div className="beneficiary-name-container mt-auto text-center cursor-pointer flex flex-col items-center max-h-[40px] overflow-hidden">
                  <span className="text-xs font-medium text-gray-700">
                    {beneficiary.accountName}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
